 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1COVER from '@/components/Book1/cover'
 import BOOK1TIT from '@/components/Book1/tit'
 import BOOK1DED from '@/components/Book1/ded'
 import BOOK1FIRST from '@/components/Book1/First'
 import BOOK1CH1 from '@/components/Book1/ch1'
 import BOOK1CH2 from '@/components/Book1/ch2'
 import BOOK1CH3 from '@/components/Book1/ch3'
 import BOOK1SECOND from '@/components/Book1/Second'
 import BOOK1CH4 from '@/components/Book1/ch4'
 import BOOK1CH5 from '@/components/Book1/ch5'
 import BOOK1CH6 from '@/components/Book1/ch6'
 import BOOK1CH7 from '@/components/Book1/ch7'
 import BOOK1CH8 from '@/components/Book1/ch8'
 import BOOK1THIRD from '@/components/Book1/Third'
 import BOOK1CH9 from '@/components/Book1/ch9'
 import BOOK1CH10 from '@/components/Book1/ch10'
 import BOOK1CH11 from '@/components/Book1/ch11'
 import BOOK1CH12 from '@/components/Book1/ch12'
 import BOOK1CH13 from '@/components/Book1/ch13'
 import BOOK1FOURTH from '@/components/Book1/Fourth'
 import BOOK1CH14 from '@/components/Book1/ch14'
 import BOOK1CH15 from '@/components/Book1/ch15'
 import BOOK1CH16 from '@/components/Book1/ch16'
 import BOOK1FIFTH from '@/components/Book1/Fifth'
 import BOOK1CH17 from '@/components/Book1/ch17'
 import BOOK1CH18 from '@/components/Book1/ch18'
 import BOOK1CH19 from '@/components/Book1/ch19'
 import BOOK1CH20 from '@/components/Book1/ch20'
 import BOOK1SIXTH from '@/components/Book1/Sixth'
 import BOOK1CH21 from '@/components/Book1/ch21'
 import BOOK1CH22 from '@/components/Book1/ch22'
 import BOOK1CH23 from '@/components/Book1/ch23'
 import BOOK1CH24 from '@/components/Book1/ch24'
 import BOOK1CH25 from '@/components/Book1/ch25'
 import BOOK1CH26 from '@/components/Book1/ch26'
 import BOOK1SEVENTH from '@/components/Book1/Seventh'
 import BOOK1CH27 from '@/components/Book1/ch27'
 import BOOK1CH28 from '@/components/Book1/ch28'
 import BOOK1CH29 from '@/components/Book1/ch29'
 import BOOK1CH30 from '@/components/Book1/ch30'
 import BOOK1EIGHTH from '@/components/Book1/Eighth'
 import BOOK1CH31 from '@/components/Book1/ch31'
 import BOOK1CH32 from '@/components/Book1/ch32'
 import BOOK1CH33 from '@/components/Book1/ch33'
 import BOOK1CH34 from '@/components/Book1/ch34'
 import BOOK1CH35 from '@/components/Book1/ch35'
 import BOOK1CH36 from '@/components/Book1/ch36'
 import BOOK1EPI from '@/components/Book1/epi'
 import BOOK1ACK from '@/components/Book1/ack'
 import BOOK2COVER from '@/components/Book2/cover'
 import BOOK2TITLE from '@/components/Book2/title'
 import BOOK2DED from '@/components/Book2/ded'
 import BOOK2CH001 from '@/components/Book2/ch001'
 import BOOK2CH002 from '@/components/Book2/ch002'
 import BOOK2CH003 from '@/components/Book2/ch003'
 import BOOK2CH004 from '@/components/Book2/ch004'
 import BOOK2CH005 from '@/components/Book2/ch005'
 import BOOK2CH006 from '@/components/Book2/ch006'
 import BOOK2CH007 from '@/components/Book2/ch007'
 import BOOK2CH008 from '@/components/Book2/ch008'
 import BOOK2CH009 from '@/components/Book2/ch009'
 import BOOK2CH010 from '@/components/Book2/ch010'
 import BOOK2CH011 from '@/components/Book2/ch011'
 import BOOK2CH012 from '@/components/Book2/ch012'
 import BOOK2CH013 from '@/components/Book2/ch013'
 import BOOK2CH014 from '@/components/Book2/ch014'
 import BOOK2CH015 from '@/components/Book2/ch015'
 import BOOK2CH016 from '@/components/Book2/ch016'
 import BOOK2CH017 from '@/components/Book2/ch017'
 import BOOK2CH018 from '@/components/Book2/ch018'
 import BOOK2CH019 from '@/components/Book2/ch019'
 import BOOK2CH020 from '@/components/Book2/ch020'
 import BOOK2CH021 from '@/components/Book2/ch021'
 import BOOK2CH022 from '@/components/Book2/ch022'
 import BOOK2CH023 from '@/components/Book2/ch023'
 import BOOK2CH024 from '@/components/Book2/ch024'
 import BOOK2CH025 from '@/components/Book2/ch025'
 import BOOK2CH026 from '@/components/Book2/ch026'
 import BOOK2CH027 from '@/components/Book2/ch027'
 import BOOK2CH028 from '@/components/Book2/ch028'
 import BOOK2CH029 from '@/components/Book2/ch029'
 import BOOK2CH030 from '@/components/Book2/ch030'
 import BOOK2CH031 from '@/components/Book2/ch031'
 import BOOK2CH032 from '@/components/Book2/ch032'
 import BOOK2CH033 from '@/components/Book2/ch033'
 import BOOK2CH034 from '@/components/Book2/ch034'
 import BOOK2CH035 from '@/components/Book2/ch035'
 import BOOK2CH036 from '@/components/Book2/ch036'
 import BOOK2CH037 from '@/components/Book2/ch037'
 import BOOK2CH038 from '@/components/Book2/ch038'
 import BOOK2CH039 from '@/components/Book2/ch039'
 import BOOK2CH040 from '@/components/Book2/ch040'
 import BOOK2CH041 from '@/components/Book2/ch041'
 import BOOK2CH042 from '@/components/Book2/ch042'
 import BOOK2CH043 from '@/components/Book2/ch043'
 import BOOK2CH044 from '@/components/Book2/ch044'
 import BOOK2CH045 from '@/components/Book2/ch045'
 import BOOK2CH046 from '@/components/Book2/ch046'
 import BOOK2CH047 from '@/components/Book2/ch047'
 import BOOK2CH048 from '@/components/Book2/ch048'
 import BOOK2CH049 from '@/components/Book2/ch049'
 import COMONBIO from '@/components/Comon/bio'
 import LOVE_2 from '@/components/love_2'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONBACKAD_1 from '@/components/Comon/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/cover",
 			"name" : "Book1/cover",
 			"component" : BOOK1COVER
 		},
 		{
 			"path" : "/Book1/tit",
 			"name" : "Book1/tit",
 			"component" : BOOK1TIT
 		},
 		{
 			"path" : "/Book1/ded",
 			"name" : "Book1/ded",
 			"component" : BOOK1DED
 		},
 		{
 			"path" : "/Book1/First",
 			"name" : "Book1/First",
 			"component" : BOOK1FIRST
 		},
 		{
 			"path" : "/Book1/ch1",
 			"name" : "Book1/ch1",
 			"component" : BOOK1CH1
 		},
 		{
 			"path" : "/Book1/ch2",
 			"name" : "Book1/ch2",
 			"component" : BOOK1CH2
 		},
 		{
 			"path" : "/Book1/ch3",
 			"name" : "Book1/ch3",
 			"component" : BOOK1CH3
 		},
 		{
 			"path" : "/Book1/Second",
 			"name" : "Book1/Second",
 			"component" : BOOK1SECOND
 		},
 		{
 			"path" : "/Book1/ch4",
 			"name" : "Book1/ch4",
 			"component" : BOOK1CH4
 		},
 		{
 			"path" : "/Book1/ch5",
 			"name" : "Book1/ch5",
 			"component" : BOOK1CH5
 		},
 		{
 			"path" : "/Book1/ch6",
 			"name" : "Book1/ch6",
 			"component" : BOOK1CH6
 		},
 		{
 			"path" : "/Book1/ch7",
 			"name" : "Book1/ch7",
 			"component" : BOOK1CH7
 		},
 		{
 			"path" : "/Book1/ch8",
 			"name" : "Book1/ch8",
 			"component" : BOOK1CH8
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js